<template>
  <div class="flex flex-col w-full">
    <SymbolInfo :isin="position.isin" />

    <div class="mb-1">
      <NButtonToggleGroup
        color="gray"
        rounded="medium"
        size="middle"
        class="w-full"
        :model-value="selectedTab"
        @update:model-value="(value) => (selectedTab = value)"
      >
        <template v-for="tab of POSITION_DETAIL_TABS" :key="tab.value">
          <NButtonToggle
            v-gid="{
              module: 'openPositionTbl',
              screen: 'home',
              section: 'openPositionInfoDialog',
              component: `openPositionInfoDialogTabs_${tab.value}`,
            }"
            :label="tab.label"
            :model-value="tab.value"
            class="w-full"
          />
        </template>
      </NButtonToggleGroup>
    </div>
    <PositionInfo :position="generatePositionInfoDialogData" />

    <PositionInfoActions :position="mappedPosition" />
  </div>
</template>

<script setup lang="ts">
import {
  PositionItemWithPrices,
  useOptionPositionDetailMapper,
} from '@core/option';

import SymbolInfo from './SymbolInfo.vue';
import PositionInfo from './PositionInfo.vue';
import PositionInfoActions from './PositionInfoActions.vue';
import { ref } from 'vue';
import { POSITION_DETAIL_TABS } from '../../constants';
import useGeneratePositionInfoDialogData from '../../utils/useGeneratePositionInfoDialogData';

type TPositionInfoDialogProps = {
  position: PositionItemWithPrices;
};

const props = defineProps<TPositionInfoDialogProps>();

const selectedTab = ref(POSITION_DETAIL_TABS.detail.value);

const mappedPosition = useOptionPositionDetailMapper(props.position);

const { generatePositionInfoDialogData } = useGeneratePositionInfoDialogData(
  selectedTab,
  props.position
);
</script>
